import script from "./windowS.vue?vue&type=script&setup=true&lang=js"
export * from "./windowS.vue?vue&type=script&setup=true&lang=js"

import "./windowS.vue?vue&type=style&index=0&id=3b4ff8ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b4ff8ce"]])

export default __exports__